import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { useAppSelector } from 'redux/Hook'
import CustomChip from 'components/Shared/Chip'
import { isMobileView } from 'lib/GlobalConstants'

const SharedFilters = () => {
  const { t } = useTranslation()
  const mobileWidth = isMobileView ? { width: '100%' } : {}
  const {
    stakeholderDashboardDetails: { displayParams = {} },
  }: any = useAppSelector((state) => state)

  const chipComponent = () => {
    const filters = Object.keys(displayParams)

    // this needs to be changed wrt the filters we get
    return filters?.length
      ? filters?.map((item, index) => {
          const displayItems = displayParams?.[item]

          return displayItems?.length ? (
            <Grid
              key={index}
              item
              {...(isMobileView && { xs: 12 })}
              display="flex"
              style={{ padding: '1.25rem 0 0 1rem', ...mobileWidth }}
            >
              <CustomChip
                filterValues={displayItems}
                key={index}
                title={t(`filters.${item}.label`)}
                variant={'outlined'}
              />
            </Grid>
          ) : null
        })
      : null
  }

  return <>{chipComponent()}</>
}

export default SharedFilters
